import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-[1360px] flex-col items-center justify-center px-4 py-20 text-center md:px-6 md:py-28">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-film-line text-4xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-4xl font-black text-foreground-950 md:text-5xl">
        404
      </h1>
      <h2 className="mt-3 font-heading text-xl font-bold text-foreground-900">
        这个页面暂时找不到
      </h2>
      <p className="mt-2 max-w-md text-sm text-foreground-600">
        你访问的页面可能已移动或不存在。返回首页，继续探索精彩的影视内容。
      </p>
      <p className="mt-1 text-xs text-foreground-400">当前路径：{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex h-11 items-center gap-2 rounded-md bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-home-4-line"></i>
          </span>
          返回首页
        </Link>
        <Link
          to="/special"
          className="flex h-11 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          浏览专题合集
        </Link>
      </div>
    </div>
  );
}